const MessagesReducer = (blogs = {}, action) => {
  switch (action.type) {
    case 'LOAD_MESSAGES':
      return (blogs = action.payload);

    case 'ADD_POST':
      return {
        ...blogs,
        post: [...blogs.post, action.payload],
      };

    case 'EDIT_POST':
      return {
        ...blogs,
        post: blogs.post.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
      };

    case 'ADD_LIKES':
      return {
        ...blogs,
        post: blogs.post.map((item) =>
          item.id === action.payload.id
            ? { ...item, likes: [...item.likes, action.payload.data] }
            : item
        ),
      };
    case 'DIS_LIKE':
      return {
        ...blogs,
        post: blogs.post.map((item) =>
          item.id === action.payload.id
            ? { ...item, likes: action.payload.data }
            : item
        ),
      };

    case 'DELETE':
      return {
        ...blogs,
        post: blogs.post.filter((item) => item.id !== action.payload),
      };

    // case 'REPLIES':
    //   return {
    //     ...blogs,
    //     post: blogs.post.map((item) =>
    //       item.id === action.payload.id
    //         ? { ...item, comments: [...item.comments, action.payload.data] }
    //         : item
    //     ),
    //   };

    default:
      return blogs;
  }
};

export default MessagesReducer;
